import { Button } from "@jds/core";
import React from "react";

export default function CloseButton(props) {
  return <Button icon={"IcClose"} kind="tertiary" {...props} />;
}
